import { render, staticRenderFns } from "./PayBoxAccountsPayableSidebar.vue?vue&type=template&id=0bc1198e&"
import script from "./PayBoxAccountsPayableSidebar.vue?vue&type=script&lang=js&"
export * from "./PayBoxAccountsPayableSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc1198e')) {
      api.createRecord('0bc1198e', component.options)
    } else {
      api.reload('0bc1198e', component.options)
    }
    module.hot.accept("./PayBoxAccountsPayableSidebar.vue?vue&type=template&id=0bc1198e&", function () {
      api.rerender('0bc1198e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-accounts-payable/PayBoxAccountsPayableSidebar.vue"
export default component.exports